import { referentialSelectorFactory } from 'state/secondaryMarket/shared/referential/referential.selector';
export const liveReferentialSelectors = referentialSelectorFactory('live', {});
